module.exports = __webpack_public_path__ + "static/img/logo-turasistan.e1f53af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-turasistan.png
// module id = snzB
// module chunks = 8